module.exports = __webpack_public_path__ + "static/img/4.9480550.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/eng/4.png
// module id = f9SX
// module chunks = 0